import type { JournalWeek, SolutionListItem } from '@loop3/universe'
import { filterSolutions, readFilters } from './solutions-library'

/** Solutions (features excluded) the knowledge base lists for a client, with the same filter as the solutions library. */
export function solutionsDelivered(
  rows: SolutionListItem[],
  prefix: string
): number {
  return filterSolutions(rows, {
    ...readFilters(new URLSearchParams()),
    type: 'solution',
    client: prefix,
  }).length
}

/** This week's meetings and Slack threads from the journal. The sub only repeats numbers when both kinds are present. */
export function weekActivity(
  weeks: readonly JournalWeek[],
  thisWeek: string
): { total: number; sub: string } {
  const counts = weeks.find((w) => w.weekStart === thisWeek)?.counts
  const meetings = counts?.meetings ?? 0
  const threads = counts?.slack_threads ?? 0
  const plural = (n: number, word: string) => (n === 1 ? word : `${word}s`)
  const sub =
    meetings && threads
      ? `${meetings} ${plural(meetings, 'meeting')} · ${threads} Slack ${plural(threads, 'thread')}`
      : meetings
        ? plural(meetings, 'meeting')
        : threads
          ? `Slack ${plural(threads, 'thread')}`
          : 'nothing journaled yet'
  return { total: meetings + threads, sub }
}
